(function () {
  "use strict";

  function productBestBuyButton() {
    console.log("bestbuy running");
    const keychronURLs = [
      {
        productURL: "/products/keychron-v1-qmk-via-custom-mechanical-keyboard?variant=40026442235993",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-v1-75-custom-wired-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-brown-switch-translucent-black/6600172.p?skuId=6600172",
      },
      {
        productURL: "/products/keychron-v1-max-qmk-via-wireless-custom-mechanical-keyboard?variant=40637899669593",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-v1-max-75-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-red-switch-black/6600175.p?skuId=6600175",
      },
      {
        productURL: "/products/keychron-v5-max-qmk-via-wireless-custom-mechanical-keyboard?variant=40759400005721",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-v5-max-96-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-red-switch-black/6600170.p?skuId=6600170",
      },
      {
        productURL: "/products/keychron-q1-he-qmk-wireless-custom-keyboard?variant=40617854435417",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-q1he-75-custom-wireless-rgb-mechanical-keyboard-with-progrmmable-qmk-via-hot-swappable-magnetic-switch-black/6600174.p?skuId=6600174",
      },
      {
        productURL: "/products/keychron-q1?variant=39951530950745",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-q1-75-custom-wired-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-brown-switch-white/6600178.p?skuId=6600178",
      },
      {
        productURL: "/products/keychron-q3-max-qmk-via-wireless-custom-mechanical-keyboard?variant=40766137499737",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-q3-max-80tkl-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-red-switch-black/6600180.p?skuId=6600180",
      },
      {
        productURL: "/products/keychron-q6-max-qmk-via-wireless-custom-mechanical-keyboard?variant=40799763005529",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-q6-max-100-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-brown-switch-black/6600176.p?skuId=6600176",
      },
      {
        productURL: "/products/keychron-q6-max-qmk-via-wireless-custom-mechanical-keyboard?variant=40799763038297",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-q6-max-100-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-banana-switch-black/6600171.p?skuId=6600171",
      },
      {
        productURL: "/products/keychron-k2-he-wireless-magnetic-switch-keyboard?variant=41846757883993",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-k2-he-75-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-magnetic-switch-black/6600481.p?skuId=6600481",
      },
      {
        productURL: "/products/keychron-k2-max-qmk-wireless-mechanical-keyboard?variant=41767492321369",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-k2-max-75-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-brown-switch-black/6600173.p?skuId=6600173",
      },
      {
        productURL: "/products/keychron-k3-max-qmk-via-wireless-custom-mechanical-keyboard?variant=40685196968025",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-k3-max-75-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-red-switch-black/6600181.p?skuId=6600181",
      },
      {
        productURL: "/products/keychron-k5-max-qmk-via-wireless-custom-mechanical-keyboard?variant=40778479763545",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-k5-max-100-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-red-switch-black/6600169.p?skuId=6600169",
      },
      {
        productURL: "/products/keychron-b1-pro-ultra-slim-wireless-keyboard?variant=41293839138905",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-b1-pro-75-wireless-keyboard-with-progrmmable-zmk-support-space-gray/6600179.p?skuId=6600179",
      },
      {
        productURL: "/products/keychron-b6-pro-ultra-slim-wireless-keyboard?variant=41293896974425",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-b6-pro-100-custom-wireless-keyboard-with-progrmmable-zmk-support-space-grey/6600177.p?skuId=6600177",
      },
    ];

    function createRedirectButton(redirectURL) {
      const button = document.createElement("a");
      button.href = redirectURL;
      button.target = "_blank";
      button.textContent = "You Can Order It On BestBuy If You're In USA";
      button.className = "convx__redirecting-to-BestBuy";
      return button;
    }

    function injectStyles() {
      const style = document.createElement("style");
      style.textContent = `
          .convx__redirecting-to-BestBuy {
            display: inline-block;
            border: var(--btn-border-width) solid rgb(var(--btn-alt-text-color));
            outline-color: rgb(var(--btn-alt-text-color));
            outline-offset: 3px;
            background: #0046be;
            color: white;
            margin-top: 15px;
            width: 100%;
            border-radius: var(--btn-border-radius, 0);
            padding: var(--btn-padding-y, 12px) 26px;
            text-align: center;
          }
          .convx__redirecting-to-BestBuy:hover {
            background: #003bb5;
          }
        `;
      document.head.appendChild(style);
    }

    function addRedirectButton(variantID) {
      const match = keychronURLs.find((item) => item.productURL.includes(variantID));
      let redirectButton = document.querySelector(".convx__redirecting-to-BestBuy");

      if (match) {
        const addToCartButton = document.querySelector(".product-info__add-to-cart");
        if (addToCartButton) {
          if (!redirectButton) {
            // Create a new button if it doesn't exist
            redirectButton = createRedirectButton(match.redirectionURL);
            addToCartButton.insertAdjacentElement("afterend", redirectButton);
          } else {
            // Update the existing button
            redirectButton.href = match.redirectionURL;
            redirectButton.textContent = "You Can Order It On BestBuy If You're In USA";
          }
        }
      } else if (redirectButton) {
        redirectButton.remove(); // Remove the button if no match is found
      }
    }

    function getCurrentVariantID() {
      // First, check for the variant in the URL query string.
      const urlParams = new URLSearchParams(window.location.search);
      const variantFromQuery = urlParams.get("variant");

      if (variantFromQuery) {
        return variantFromQuery;
      }

      // Look for the active variant ID in the DOM (commonly used in Shopify).
      const activeVariantInput = document.querySelector('input[name="id"][value]:checked');
      if (activeVariantInput) {
        return activeVariantInput.value;
      }

      return null;
    }

    function observeVariantChange() {
      // const targetNode = document.body; // Observe changes anywhere on the page.
      // const config = { childList: true, subtree: true };

      // const observer = new MutationObserver(() => {
      //   const currentVariantID = getCurrentVariantID();
      //   if (currentVariantID) {
      //     addRedirectButton(currentVariantID);
      //   }
      // });

      // observer.observe(targetNode, config);
      //   const swatchesContainer = document.querySelector(".product-info__block.product-options");

      //   if (!swatchesContainer) return;

      //   let isProcessing = false;

      //   const observer = new MutationObserver((mutations) => {
      //       if (isProcessing) return; // Prevent multiple executions in quick succession

      //       isProcessing = true; // Set flag to prevent immediate re-execution

      //       mutations.some((mutation) => {
      //           if (mutation.target.closest(".swatch-view-item")) {
      //               console.log("%c Swatches container changed:", "color: #A3DE2D;", mutation);

      //               const currentVariantID = getCurrentVariantID();
      //               if (currentVariantID) {
      //                   console.log(currentVariantID);
      //                   addRedirectButton(currentVariantID);
      //               }

      //               setTimeout(() => isProcessing = false, 100); // Reset flag after a short delay
      //               return true; // Stop processing after the first match
      //           }
      //           return false; // Continue checking other mutations if not matched
      //       });
      //   });

      //   observer.observe(swatchesContainer, {
      //       childList: true,
      //       subtree: true,
      //       attributes: true
      //   });

      document.addEventListener("click", (event) => {
        const swatchItem = event.target.closest(".swatch-view-item");

        if (!swatchItem) return; // Exit if the click is not on a swatch item

        console.log("%c Swatch clicked:", "color: #A3DE2D;", swatchItem);

        const currentVariantID = getCurrentVariantID();
        if (currentVariantID) {
          console.log(currentVariantID);
          addRedirectButton(currentVariantID);
        }
      });

      // Initial check for the current variant.
      const initialVariantID = getCurrentVariantID();
      if (initialVariantID) {
        addRedirectButton(initialVariantID);
      }
    }

    function init() {
      injectStyles();
      observeVariantChange();
    }

    init();
  }

  function product_ratings() {
    // Select the product element
    const productElement = document.querySelector(".product.js-product");
    if (!productElement) {
      console.error("Product element '.product.js-product' not found.");
      return;
    }

    const ratingValue = parseFloat(productElement.dataset.ratingValue);
    const ratingCount = parseInt(productElement.dataset.ratingCount, 10);

    if (isNaN(ratingValue)) {
      // console.error("Invalid or missing 'data-rating-value'.");
      return;
    }

    // Calculate stars rating
    const decimal = ratingValue % 1;
    let starsRating = Math.floor(ratingValue);

    if (decimal >= 0.3 && decimal <= 0.7) {
      starsRating += 0.5;
    } else if (decimal > 0.7) {
      starsRating = Math.ceil(ratingValue);
    }

    const scaleMax = 5; // Assuming 5 as the maximum rating scale

    // Create the rating HTML
    const ratingHTML = `
        <div class="rating inline-block align-middle" role="img" 
          aria-label="${ratingValue} out of ${scaleMax} stars">
          <span class="rating__stars" aria-hidden="true" 
            style="--rating: ${starsRating}; --rating-max: ${scaleMax};">★★★★★</span>
        </div>
        ${!isNaN(ratingCount) ? `<div class="rating__count inline-block align-middle text-sm">(${ratingCount})</div>` : ""}
      `;

    // Select the product price element
    const productPrice = document.querySelector(".product-info__price");
    if (!productPrice) {
      console.error("Product price element '.product-info__price' not found.");
      return;
    }

    // Create a container for the rating and append it after .product-info__price
    const ratingContainer = document.createElement("div");
    ratingContainer.classList.add("product-rating");
    ratingContainer.innerHTML = ratingHTML;

    productPrice.insertAdjacentElement("afterend", ratingContainer);
    console.log("Rating element successfully appended.");
  }

  function addonsAccordion() {
    class ConvxAddonsAccordion extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initAccordion();
        this.initCheckboxListeners();
      }

      initAccordion() {
        const buttons = this.querySelectorAll(".convx__addons-accordion");

        buttons.forEach((button) => {
          button.addEventListener("click", () => {
            const panel = button.nextElementSibling;
            const isOpen = button.classList.contains("active");

            // Close all panels
            // this.querySelectorAll(".convx__addons-accordion").forEach((btn) => {
            //   btn.classList.remove("active");
            //   btn.nextElementSibling.style.maxHeight = null;
            //   btn.nextElementSibling.style.paddingBottom = null;
            // });

            // if (!isOpen) {
            //   button.classList.add("active");
            //   panel.style.maxHeight = panel.scrollHeight + 15 + "px";
            //   panel.style.paddingBottom = 15 + "px";
            // }

            if (isOpen) {
              button.classList.remove("active");
              panel.style.maxHeight = null;
              panel.style.paddingBottom = null;
            } else {
              button.classList.add("active");
              panel.style.maxHeight = panel.scrollHeight + 100 + "px";
              panel.style.paddingBottom = 15 + "px";
            }
          });
        });
      }
      initCheckboxListeners() {
        const checkboxes = this.querySelectorAll(".addons-option input[type='checkbox']");
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener("change", () => {
                const parentLabel = checkbox.closest(".addons-option");
                const quantityInput = parentLabel.querySelector("input[type='hidden']");
                
                if (checkbox.checked) {
                    parentLabel.classList.add("active");
                    quantityInput.disabled = false;
                } else {
                    parentLabel.classList.remove("active");
                    quantityInput.disabled = true;
                }
            });
        });
      }
      getCheckedValues() {
        const checkedValues = [];
        this.querySelectorAll("input[type='checkbox']:checked").forEach((input) => {
          checkedValues.push(input.value);
        });
        return checkedValues;
      }
    }

    window.customElements.define("convx-addons", ConvxAddonsAccordion);
  }

  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    addonsAccordion();

    if (isProducts) {
      product_ratings();
      productBestBuyButton();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
